import { useEffect, useRef, useState } from 'react';
import englishFlag from '../../assets/flag-en.svg';
import frenchFlag from '../../assets/flag-fr.svg';
import { useLanguage } from '../../context/LanguageContext';

const LANGUAGE_OPTIONS = [
  { code: 'en', labelKey: 'language.english', flag: englishFlag },
  { code: 'fr', labelKey: 'language.french', flag: frenchFlag },
];

const LanguageSwitcher = () => {
  const [open, setOpen] = useState(false);
  const { language, setLanguage, t } = useLanguage();
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickAway = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener('click', handleClickAway);
    return () => document.removeEventListener('click', handleClickAway);
  }, []);

  const activeOption =
    LANGUAGE_OPTIONS.find((item) => item.code === language) ||
    LANGUAGE_OPTIONS[0];

  const handleSelect = (code) => {
    setOpen(false);
    setLanguage(code);
  };

  return (
    <div
      className={`language-switcher ${open ? 'language-switcher--open' : ''}`}
      ref={containerRef}
    >
      <button
        type='button'
        className='language-switcher__toggle'
        onClick={(event) => {
          event.stopPropagation();
          setOpen((prev) => !prev);
        }}
        aria-haspopup='listbox'
        aria-expanded={open}
      >
        <img
          src={activeOption.flag}
          alt={`${t(activeOption.labelKey)} flag`}
          className='language-switcher__flag'
        />
    
      
      </button>

      {open && (
        <div className='language-switcher__menu' role='listbox'>
          {LANGUAGE_OPTIONS.map((option) => (
            <button
              type='button'
              key={option.code}
              className={`language-switcher__option ${
                option.code === activeOption.code
                  ? 'language-switcher__option--active'
                  : ''
              }`}
              onClick={(event) => {
                event.stopPropagation();
                handleSelect(option.code);
              }}
            >
              <img
                src={option.flag}
                alt=''
                aria-hidden='true'
                className='language-switcher__flag'
              />
        <span>{t(option.labelKey)}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
